import { collectNumbers, numericExtent, pivotHighLowSeries } from "../utils";
const PIVOT_TYPES = ["standard", "fibonacci"];
const PivotHighLow = {
    name: "PivotHighLow",
    compute: (bars, lookback = 10, pivotType = 0) => {
        const typeStr = PIVOT_TYPES[pivotType] || "standard";
        return pivotHighLowSeries(bars, lookback, typeStr);
    },
    computeExtents: (values) => numericExtent(collectNumbers(values)),
    render: () => undefined,
};
export default PivotHighLow;
